import { deleteUser, signOut } from "firebase/auth";
import type { Auth } from "firebase/auth";

export const createAuthCleanup = (auth: Auth) => {
	const cleanupTransientAuthState = async () => {
		if (auth.currentUser) {
			await signOut(auth);
		}
	};

	const cleanupRecentCreatedUserByEmail = async (email: string) => {
		const currentUser = auth.currentUser;
		if (!currentUser) return;
		if ((currentUser.email || "").toLowerCase() !== email.toLowerCase()) return;

		const creationTime = currentUser.metadata?.creationTime
			? Date.parse(currentUser.metadata.creationTime)
			: NaN;
		if (!Number.isFinite(creationTime)) {
			await cleanupTransientAuthState();
			return;
		}

		if (Date.now() - creationTime <= 5 * 60 * 1000) {
			try {
				await deleteUser(currentUser);
			} catch {
				await cleanupTransientAuthState();
			}
		}
	};

	return {
		cleanupTransientAuthState,
		cleanupRecentCreatedUserByEmail,
	};
};
